module.exports = __webpack_public_path__ + "static/media/footer-logo.eb3c115a.svg";